import { Action, createReducer, on } from "@ngrx/store";
import * as fromActiveLanguages from "../actions/active-languages.action";
import { Language } from "cli-types";

export interface ActiveLanguagesState {
    entities: Map<number, Language>;
    loaded: boolean;
    loading: boolean;
}

export const initialState: ActiveLanguagesState = {
    entities: new Map<number, Language>(),
    loaded: false,
    loading: false,
};
const activeLanguagesReducer = createReducer(
    initialState,
    on(fromActiveLanguages.loadActiveLanguages, (state, { payload }) => {
        return {
            ...state,
            loaded: false,
            loading: true,
        };
    }),
    on(fromActiveLanguages.loadActiveLanguagesSuccess, (state, { payload }) => {
        const activeLanguages = payload;

        const entities = new Map<number, Language>();
        activeLanguages.forEach((activeLanguage) => {
            entities.set(activeLanguage.languageID, activeLanguage);
        });

        return {
            ...state,
            loaded: true,
            loading: false,
            entities,
        };
    }),
    on(fromActiveLanguages.loadActiveLanguagesFail, (state, { payload }) => {
        return {
            ...state,
            loaded: false,
            loading: false,
        };
    })
);
export function reducer(
    state: ActiveLanguagesState | undefined,
    action: Action
) {
    return activeLanguagesReducer(state, action);
}

export const getActiveLanguagesEntities = (state: ActiveLanguagesState) =>
    state.entities;
export const getActiveLanguagesLoading = (state: ActiveLanguagesState) =>
    state.loading;
export const getActiveLanguagesLoaded = (state: ActiveLanguagesState) =>
    state.loaded;
